import { SiteData } from '../types';

export const siteData: SiteData = {
  companyInfo: {
    name: "AKC Mekanik İnşaat",
    description: {
      tr: "AKC Mekanik İnşaat, sigorta şirketlerinin hızla gelişmekte olan satış sonrası hizmet anlayışına kurumsal bir bakış açısı ve müşteri memnuniyetini en üst seviyede tutmak amacı ile konut ve işyeri poliçelerinde satış sonrası oluşabilecek hasarları gidermek için hizmet vermeye devam etmektedir.",
      en: "AKC Mechanical Construction continues to provide services to eliminate post-sale damages that may occur in residential and commercial policies, with a corporate perspective on the rapidly developing post-sale service approach of insurance companies and with the aim of keeping customer satisfaction at the highest level."
    },
    mission: {
      tr: "AKC Mekanik İnşaat olarak, yurtiçi ve yurtdışı rekabet edebilirlik anlayışından yola çıkıp faaliyet gösterdiğimiz her sektörde en mükemmelini yakalamak, şirket olarak teknolojik gelişmeleri yakından izleyip, sektör ihtiyaçlarına yönelik projeler üretmek ve uygulamak.",
      en: "As AKC Mechanical Construction, starting from the understanding of domestic and international competitiveness, to achieve the best in every sector we operate, to closely follow technological developments as a company, and to produce and implement projects for sector needs."
    },
    vision: {
      tr: "Satış Sonrası Hizmetler alanında, ürün ve hizmet sağlayıcılarla, ürün ve hizmet almak isteyen herkesi bir araya getirip, her iki tarafında ihtiyaçlarına en inovatif çalışmalar ve son teknolojik sistemlerle ihtiyaçları karşılamak için var gücüyle çalışarak değer katmaya ve fark yaratmaya devam etmektir.",
      en: "In the field of After-Sales Services, to bring together product and service providers with everyone who wants to receive products and services, and to continue to add value and make a difference by working with all our strength to meet the needs of both parties with the most innovative work and latest technological systems."
    }
  },
  hero: {
    title: {
      tr: "Sigorta Hasarlarında Hızlı ve Güvenilir Çözüm Ortağınız",
      en: "Your Fast and Reliable Solution Partner for Insurance Damages"
    },
    subtitle: {
      tr: "AKC Mekanik İnşaat konusunda uzman ekip ve ekipmanları ile hasar onarımı ve restorasyon alanında en kısa sürede müdahalede bulunup oluşabilecek hasarı asgari seviyeye indirmeyi ilke edinerek, ekonomik çözümler ile hizmet vermeye devam etmektedir.",
      en: "AKC Mechanical Construction continues to provide services with economic solutions, with the principle of intervening in the shortest time in the field of damage repair and restoration with expert teams and equipment, and reducing possible damage to a minimum level."
    },
    backgroundImage: "/images/hero-bg.jpg"
  },
  about: {
    title: {
      tr: "10 Yıllık Deneyimimizle Yanınızdayız",
      en: "We Are With You With 10 Years of Experience"
    },
    description: {
      tr: "AKC Mekanik İnşaat olarak, sigorta şirketlerinin hızla gelişmekte olan satış sonrası hizmet anlayışına kurumsal bir bakış açısı getiriyoruz. Konut ve işyeri poliçelerinde satış sonrası oluşabilecek hasarları gidermek için profesyonel hizmet vermeye devam etmektedir.",
      en: "As AKC Mechanical Construction, we bring a corporate perspective to the rapidly developing post-sale service approach of insurance companies. We continue to provide professional services to eliminate post-sale damages that may occur in residential and commercial policies."
    },
    mission: {
      tr: "Yurtiçi ve yurtdışı rekabet edebilirlik anlayışından yola çıkıp faaliyet gösterdiğimiz her sektörde en mükemmelini yakalamak, şirket olarak teknolojik gelişmeleri yakından izleyip, sektör ihtiyaçlarına yönelik projeler üretmek ve uygulamak.",
      en: "Starting from the understanding of domestic and international competitiveness, to achieve the best in every sector we operate, to closely follow technological developments as a company, and to produce and implement projects for sector needs."
    },
    vision: {
      tr: "Satış Sonrası Hizmetler alanında, ürün ve hizmet sağlayıcılarla, ürün ve hizmet almak isteyen herkesi bir araya getirip, her iki tarafında ihtiyaçlarına en inovatif çalışmalar ve son teknolojik sistemlerle değer katmaya ve fark yaratmaya devam etmektir.",
      en: "In the field of After-Sales Services, to bring together product and service providers with everyone who wants to receive products and services, and to continue to add value and make a difference with the most innovative work and latest technological systems to meet the needs of both parties."
    },
    features: {
      tr: [
        "Şeffaflık ve Dürüstlük",
        "7/24 Acil Müdahale Hizmeti",
        "Uzman ve Sertifikalı Ekip",
        "Teknolojik Altyapı",
        "Müşteri Odaklı Hizmet",
        "Kaliteli Ürün ve Hizmet"
      ],
      en: [
        "Transparency and Honesty",
        "24/7 Emergency Response Service",
        "Expert and Certified Team",
        "Technological Infrastructure",
        "Customer-Focused Service",
        "Quality Products and Services"
      ]
    },
    socialResponsibility: {
      tr: "AKC Mekanik İnşaat olarak topluma ve çevreye duyarlı projeler geliştirmeye, sosyal sorumluluk bilinciyle hareket etmeye önem veriyoruz. Eğitim, çevre ve toplumsal dayanışma alanlarında çeşitli sosyal sorumluluk projelerine destek veriyoruz.",
      en: "As AKC Mechanical Construction, we attach importance to developing projects sensitive to society and the environment, and to acting with a sense of social responsibility. We support various social responsibility projects in the fields of education, environment, and social solidarity."
    }
  },
  services: [
    {
      id: "konut-isyeri-onarim",
      title: {
        tr: "Konut / İş Yeri Hasar Onarımı",
        en: "Residential / Commercial Damage Repair"
      },
      description: {
        tr: "Konut ve iş yerinizde oluşan su, yangın, fırtına, sel, izolasyon yetersizliği gibi hasarların onarımı profesyonel ekibimiz tarafından yapılır.",
        en: "Repair of damages such as water, fire, storm, flood, insulation inadequacy in your home and workplace is carried out by our professional team."
      },
      icon: "🏠",
      features: {
        tr: ["7/24 Acil Müdahale", "Hızlı Hasar Tespiti", "Ekonomik Çözümler", "Garantili Onarım"],
        en: ["24/7 Emergency Response", "Fast Damage Assessment", "Economic Solutions", "Guaranteed Repair"]
      },
      details: {
        tr: "Her hasar dosyasına ilgili bir müşteri temsilcisi atanır, müşteri memnuniyeti en yüksek seviyede tutulur, hasarın her aşaması kontrol altındadır.",
        en: "A relevant customer representative is assigned to each damage file, customer satisfaction is kept at the highest level, every stage of the damage is under control."
      },
      equipment: {
        tr: ["Dinleme cihazı", "Tıkanıklık açma robotu", "Gider görüntüleme cihazı"],
        en: ["Listening device", "Blockage opening robot", "Drain imaging device"]
      },
      projects: {
        tr: ["Konut ve işyeri su baskını onarımları", "Yangın sonrası restorasyonlar"],
        en: ["Residential and commercial flood repairs", "Post-fire restorations"]
      },
      process: {
        tr: "Hasar bildirimi sonrası hızlı ekspertiz, müşteri ile iletişim, onarım ve teslimat.",
        en: "Fast expertise after damage notification, communication with customer, repair and delivery."
      }
    },
    {
      id: "endustriyel-onarim",
      title: {
        tr: "Endüstriyel Hasar Onarımı",
        en: "Industrial Damage Repair"
      },
      description: {
        tr: "Fabrika, depo ve endüstriyel tesislerde oluşan büyük çaplı hasarların onarımı ve restorasyonu.",
        en: "Repair and restoration of large-scale damages in factories, warehouses, and industrial facilities."
      },
      icon: "🏭",
      features: {
        tr: ["Endüstriyel Uzmanlık", "Büyük Ölçekli Projeler", "Hızlı Müdahale", "Garantili Çözüm"],
        en: ["Industrial Expertise", "Large Scale Projects", "Rapid Response", "Guaranteed Solution"]
      },
      details: {
        tr: "Endüstriyel tesislerde yangın, su baskını, makine arızası gibi durumlarda hızlı ve etkili onarım.",
        en: "Fast and effective repair in cases such as fire, flood, machine failure in industrial facilities."
      },
      equipment: {
        tr: ["Endüstriyel kurutma cihazı", "Ağır ekipmanlar", "Özel onarım araçları"],
        en: ["Industrial drying device", "Heavy equipment", "Special repair tools"]
      },
      projects: {
        tr: ["Fabrika yangın onarımları", "Depo su baskını restorasyonları"],
        en: ["Factory fire repairs", "Warehouse flood restorations"]
      },
      process: {
        tr: "Ekspertiz, planlama, onarım ve teslimat.",
        en: "Expertise, planning, repair and delivery."
      }
    },
    {
      id: "kurumsal-tadilat",
      title: {
        tr: "Kurumsal Tadilat & Dekorasyon",
        en: "Corporate Renovation & Decoration"
      },
      description: {
        tr: "Kurumsal firmalara ofis, mağaza ve şube tadilatı, dekorasyon ve yenileme hizmetleri. (Örnek: Vestel ve Vakıfbank şubeleri tadilatı)",
        en: "Renovation, decoration and renewal services for corporate offices, stores and branches. (e.g. Vestel and Vakıfbank branch renovations)"
      },
      icon: "🏢",
      features: {
        tr: ["Ofis ve Şube Tadilatı", "Kurumsal Dekorasyon", "Anahtar Teslim Proje", "Hızlı Teslimat"],
        en: ["Office and Branch Renovation", "Corporate Decoration", "Turnkey Project", "Fast Delivery"]
      },
      details: {
        tr: "Kurumsal müşterilere özel anahtar teslim tadilat ve dekorasyon çözümleri.",
        en: "Turnkey renovation and decoration solutions for corporate clients."
      },
      equipment: {
        tr: ["İç mimari ekipmanlar", "Dekorasyon malzemeleri", "Profesyonel ekip"],
        en: ["Interior architectural equipment", "Decoration materials", "Professional team"]
      },
      projects: {
        tr: ["Vestel şube tadilatı", "Vakıfbank şube yenilemesi"],
        en: ["Vestel branch renovation", "Vakıfbank branch renewal"]
      },
      process: {
        tr: "Keşif, tasarım, uygulama ve teslimat.",
        en: "Exploration, design, implementation and delivery."
      }
    },
    {
      id: "mimari-hizmetler",
      title: {
        tr: "Mimari Hizmetler",
        en: "Architectural Services"
      },
      description: {
        tr: "İnşaat, tadilat ve dekorasyon alanında kapsamlı mimari hizmetler.",
        en: "Comprehensive architectural services in construction, renovation and decoration."
      },
      icon: "🏗️",
      features: {
        tr: ["Proje Tasarımı", "Uygulama", "İnce İşçilik", "Danışmanlık"],
        en: ["Project Design", "Implementation", "Fine Craftsmanship", "Consultancy"]
      },
      details: {
        tr: "Mimari proje tasarımı, uygulama ve danışmanlık hizmetleri.",
        en: "Architectural project design, implementation and consultancy services."
      },
      equipment: {
        tr: ["Tasarım yazılımları", "Uygulama ekipmanları"],
        en: ["Design software", "Implementation equipment"]
      },
      projects: {
        tr: ["Ofis projeleri", "Mağaza uygulamaları"],
        en: ["Office projects", "Store applications"]
      },
      process: {
        tr: "Tasarım, uygulama ve teslimat.",
        en: "Design, implementation and delivery."
      }
    },
    {
      id: "elektrik-hizmetler",
      title: {
        tr: "Elektrik Hizmetleri",
        en: "Electrical Services"
      },
      description: {
        tr: "Elektrik tesisatı, aydınlatma ve güç sistemleri kurulumu ve bakımı.",
        en: "Installation and maintenance of electrical wiring, lighting and power systems."
      },
      icon: "⚡",
      features: {
        tr: ["Elektrik Tesisatı", "Aydınlatma Sistemleri", "Güç Sistemleri", "Bakım ve Onarım"],
        en: ["Electrical Wiring", "Lighting Systems", "Power Systems", "Maintenance and Repair"]
      },
      details: {
        tr: "Elektrik tesisatı kurulumu, bakım ve onarım hizmetleri.",
        en: "Installation, maintenance and repair services for electrical wiring."
      },
      equipment: {
        tr: ["Elektrik ekipmanları", "Test cihazları"],
        en: ["Electrical equipment", "Testing devices"]
      },
      projects: {
        tr: ["Ofis elektrik projeleri", "Aydınlatma uygulamaları"],
        en: ["Office electrical projects", "Lighting applications"]
      },
      process: {
        tr: "Keşif, uygulama ve teslimat.",
        en: "Exploration, implementation and delivery."
      }
    },
    {
      id: "mekanik-tesisat",
      title: {
        tr: "Mekanik Tesisat Hizmetleri",
        en: "Mechanical Installation Services"
      },
      description: {
        tr: "Isıtma-soğutma, havalandırma ve yangın sistemleri tasarımı ve uygulaması.",
        en: "Design and implementation of heating-cooling, ventilation and fire systems."
      },
      icon: "⚙️",
      features: {
        tr: ["Isıtma-Soğutma Sistemleri", "Havalandırma Sistemleri", "Yangın Sistemleri", "Bakım ve Onarım"],
        en: ["Heating-Cooling Systems", "Ventilation Systems", "Fire Systems", "Maintenance and Repair"]
      },
      details: {
        tr: "Isıtma-soğutma, havalandırma ve yangın sistemleri için tasarım, uygulama ve bakım hizmetleri.",
        en: "Design, implementation and maintenance services for heating-cooling, ventilation and fire systems."
      },
      equipment: {
        tr: ["Mekanik tesisat ekipmanları", "Bakım araçları"],
        en: ["Mechanical installation equipment", "Maintenance tools"]
      },
      projects: {
        tr: ["Endüstriyel tesis uygulamaları", "Bina mekanik sistemleri"],
        en: ["Industrial facility applications", "Building mechanical systems"]
      },
      process: {
        tr: "Tasarım, uygulama ve teslimat.",
        en: "Design, implementation and delivery."
      }
    }
  ],
  references: [
    {
      id: "turkiye-sigorta",
      name: "Türkiye Sigorta",
      logo: "🇹🇷",
      sector: { tr: "Sigorta", en: "Insurance" }
    },
    {
      id: "magdeburger-sigorta",
      name: "Magdeburger Sigorta",
      logo: "🇩🇪",
      sector: { tr: "Sigorta", en: "Insurance" }
    },
    {
      id: "allianz-sigorta",
      name: "Allianz Sigorta",
      logo: "🇩🇪",
      sector: { tr: "Sigorta", en: "Insurance" }
    },
    {
      id: "eureko-sigorta",
      name: "Eureko Sigorta",
      logo: "🇳🇱",
      sector: { tr: "Sigorta", en: "Insurance" }
    }
  ],
  contactInfo: {
    phone: "+90 537 295 96 12",
    whatsapp: "+90 537 295 96 12",
    email: "info@akcmekanik.com",
    address: {
      tr: "Madenler Mah. Erkan Sk. No:2 D:7 Ümraniye/İSTANBUL",
      en: "Madenler District, Erkan Street, No:2 D:7 Ümraniye/ISTANBUL"
    },
    workingHours: {
      tr: "Pazartesi - Cuma: 08:00 - 18:00",
      en: "Monday - Friday: 08:00 - 18:00"
    }
  }
};
